/**
 * Components: Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter
 * A minimal card UI primitive collection. Provides structure with consistent
 * spacing and dark-mode aware colors. Each sub-component accepts `className`
 * for customization and passes through remaining props.
 */
import React from 'react';

export function Card({ className = '', children, onClick, ...props }) {
  return (
    <div 
      onClick={onClick}
      className={`rounded-lg border border-gray-200 bg-white dark:border-gray-800 dark:bg-gray-900 ${onClick ? 'cursor-pointer' : ''} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}

export function CardHeader({ className = '', children, ...props }) {
  return (
    <div className={`flex flex-col space-y-1.5 p-6 ${className}`} {...props}>
      {children}
    </div>
  );
}

export function CardTitle({ className = '', children, ...props }) {
  return (
    <h3 className={`text-2xl font-semibold leading-none tracking-tight text-gray-900 dark:text-white ${className}`} {...props}>
      {children}
    </h3>
  );
}

export function CardDescription({ className = '', children, ...props }) {
  return (
    <p className={`text-sm text-gray-600 dark:text-gray-400 ${className}`} {...props}>
      {children}
    </p>
  );
}

export function CardContent({ className = '', children, ...props }) {
  return (
    <div className={`p-6 ${className}`} {...props}>
      {children}
    </div>
  );
}

export function CardFooter({ className = '', children, ...props }) {
  return (
    <div className={`flex items-center p-6 pt-0 ${className}`} {...props}>
      {children}
    </div>
  );
}